import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { UseMutationOptions } from '@/types/queries'

export function useDeleteLocalPqResourceSetMutation(options?: UseMutationOptions<void, string>) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (resourceSetId: string) => pqClient.deleteResourceSet(resourceSetId),
  })

  return { deleteResourceSet: mutateAsync, ...mutationResult }
}
